import styled from 'styled-components'

export const StickyBarStyled = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndex.navigation};
  padding: ${({ theme }) => `${theme.space.medium} ${theme.space.xlarge}`};
  background: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.content.border};
`
